import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { turnitinGetEulaSuccess, turnitinGetEulaFailure, turnitinGetEulaRequest } from '../reducers/turnitin';

import { API_LINK } from '../../constants';
import moment from 'moment';
import { setEula, showEula } from '../reducers/popi';

const API = `${API_LINK}`;




function* turnitinGetEulaFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user,
    token,
  } = state.loginReducer;
  

  const response = yield call(() =>
    axios({
      method: 'get',
      url: API+'/api/tii_getHtml' ,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin'
    }),
  );

  return response;
}

function* workerTurnitinGetEulaSaga() {
  try {
   
    const response = yield call(turnitinGetEulaFunctionAxios);
    const responseFromTurnitinEula = response.data;
   
    if (response.status === 200) {
        console.log('Shaun Eula',responseFromTurnitinEula)
        yield put(setEula(responseFromTurnitinEula));
        yield put(showEula(true));
    }
    if (response.status === 201) {
      yield put(turnitinGetEulaFailure(responseFromTurnitinEula.message));
    }
  } catch (error) {
   
    yield put(turnitinGetEulaFailure(error.message));
  }
}

export function* watcherTurnitinGetEulaSaga() {
  yield takeLatest(turnitinGetEulaRequest().type, workerTurnitinGetEulaSaga);
}
